// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_BasicURL from "../Data.BasicURL/index.js";
import * as Data_Duration from "../Data.Duration/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Time_Duration from "../Data.Time.Duration/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_Styled from "../Halogen.Styled/index.js";
import * as Halogen_Styled_DSL from "../Halogen.Styled.DSL/index.js";
import * as Visonum_API_SpeedMaster from "../Visonum.API.SpeedMaster/index.js";
import * as Visonum_BulkPingApp_AppHTML from "../Visonum.BulkPingApp.AppHTML/index.js";
import * as Visonum_BulkPingApp_Components_App_Types from "../Visonum.BulkPingApp.Components.App.Types/index.js";
import * as Visonum_BulkPingApp_Views_PrimaryButton from "../Visonum.BulkPingApp.Views.PrimaryButton/index.js";
var inline = /* #__PURE__ */ Halogen_Styled_DSL.inline();
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var show = /* #__PURE__ */ Data_Show.show(Visonum_API_SpeedMaster.showBulkPingJobStatus);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(Data_Ord.ordString);
var show1 = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var pure = /* #__PURE__ */ Control_Applicative.pure(Control_Applicative.applicativeArray);
var show2 = /* #__PURE__ */ Data_Show.show(Data_Show.showNumber);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var fromDuration = /* #__PURE__ */ Data_Time_Duration.fromDuration(Data_Duration.durationDuration);
var show3 = /* #__PURE__ */ Data_Show.show(Data_Show.showBoolean);
var viewData = function (data_) {
    var elValue = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("DetailsPanelValue")([ inline({
        fontSize: "10px",
        fontFamily: "Arial"
    }) ]);
    var elRow = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("DetailsPanelRow")([ inline({
        display: "flex",
        flexDirection: "row",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "10px"
    }) ]);
    var elRoot = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("DetailsPanel")([ inline({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        justifyContent: "end",
        alignItems: "center",
        gap: "15px"
    }) ]);
    var elKey = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("DetailsPanelKey")([ inline({
        fontSize: "12px",
        fontWeight: "bold",
        fontFamily: "Arial"
    }) ]);
    var elItem = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("DetailsPanelItem")([ inline({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: "5px",
        backgroundColor: "#f0f0f0",
        border: "1px solid #e0e0e0",
        borderRadius: "5px",
        padding: "5px"
    }) ]);
    return elRoot([  ])(map(function (row) {
        return elRow([  ])(map(function (item) {
            return elItem([  ])([ elKey([  ])([ Halogen_Styled.text(item.key) ]), elValue([  ])([ item.value ]) ]);
        })(row));
    })(data_));
};
var view = function (state) {
    var elRoot = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("DetailsPanel")([ inline({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        justifyContent: "end",
        alignItems: "center",
        padding: "15px",
        gap: "30px"
    }) ]);
    var elResults = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("DetailsPanelResults")([ inline({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        justifyContent: "end",
        alignItems: "center",
        gap: "15px"
    }) ]);
    var elLine = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("DetailsPanelLine")([ inline({
        width: "100%",
        height: "1px",
        backgroundColor: "#e0e0e0"
    }) ]);
    var elJobId = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("DetailsPanelJobId")([ inline({
        fontSize: "12px",
        fontWeight: "bold",
        fontFamily: "Arial"
    }) ]);
    var elBottomBar = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("DetailsPanelBottomBar")([ inline({
        display: "flex",
        flexDirection: "row",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        gap: "15px"
    }) ]);
    return elRoot([  ])([ (function () {
        if (state.details instanceof Data_Maybe.Just && (state.details.value0.result instanceof Data_Maybe.Just && state.details.value0.result.value0 instanceof Data_Either.Right)) {
            return elResults([  ])([ viewData([ [ {
                key: "Job ID",
                value: elJobId([  ])([ Halogen_Styled.text(state.details.value0.jobId) ])
            } ], [ {
                key: "Status",
                value: Halogen_Styled.text(Data_Maybe.fromMaybe("N/A")(map1(function (r) {
                    return show(r.status);
                })(lookup(state.details.value0.jobId)(state.bulkPingStatus.jobs))))
            }, {
                key: "Number of Errors",
                value: Halogen_Styled.text(Data_Maybe.fromMaybe("N/A")(map1(function (r) {
                    return show1(r.errorsCount);
                })(lookup(state.details.value0.jobId)(state.bulkPingStatus.jobs))))
            } ] ]), elLine([  ])([  ]), viewData(map(pure)([ {
                key: "Agent URL",
                value: Halogen_Styled.text(Data_BasicURL.print(state.details.value0.result.value0.value0.config.agentUrl))
            }, {
                key: "Ping Count per IP",
                value: Halogen_Styled.text(show1(state.details.value0.result.value0.value0.config.pingCountPerIp))
            }, {
                key: "Interval Between Pings (ms)",
                value: Halogen_Styled.text(show2(unwrap(fromDuration(state.details.value0.result.value0.value0.config.intervalBetweenPingsMillis))))
            }, {
                key: "Interval Between IPs (ms)",
                value: Halogen_Styled.text(show2(unwrap(fromDuration(state.details.value0.result.value0.value0.config.intervalBetweenIpsMillis))))
            }, {
                key: "Use TCP SYN to Port",
                value: Halogen_Styled.text((function () {
                    if (state.details.value0.result.value0.value0.config.useSynToPort instanceof Data_Maybe.Just) {
                        return show1(state.details.value0.result.value0.value0.config.useSynToPort.value0);
                    };
                    if (state.details.value0.result.value0.value0.config.useSynToPort instanceof Data_Maybe.Nothing) {
                        return "false";
                    };
                    throw new Error("Failed pattern match at Visonum.BulkPingApp.DetailsPanel (line 116, column 37 - line 118, column 43): " + [ state.details.value0.result.value0.value0.config.useSynToPort.constructor.name ]);
                })())
            }, {
                key: "Use ICMP",
                value: Halogen_Styled.text(show3(state.details.value0.result.value0.value0.config.useIcmp))
            } ])), elBottomBar([  ])([ Visonum_BulkPingApp_Views_PrimaryButton.view({
                label: "Download JSON",
                onClick: new Visonum_BulkPingApp_Components_App_Types.DownloadResults(state.details.value0.jobId, Visonum_BulkPingApp_Components_App_Types.DownloadJson.value),
                disabled: false
            }), Visonum_BulkPingApp_Views_PrimaryButton.view({
                label: "Download CSV",
                onClick: new Visonum_BulkPingApp_Components_App_Types.DownloadResults(state.details.value0.jobId, Visonum_BulkPingApp_Components_App_Types.DownloadCsv.value),
                disabled: false
            }) ]) ]);
        };
        return Halogen_Styled.text("");
    })() ]);
};
export {
    view
};
//# sourceMappingURL=index.js.map
